const ProtectionList = () => import('../../views/product/ProtectionList.vue');
const ProtectionEdit = () => import('../../views/product/ProtectionEdit.vue');
const ProductList = () => import('../../views/product/ProductList.vue');
const ProductEdit = () => import('../../views/product/ProductEdit.vue');
const ProductClassList = () => import('../../views/product/ProductClassList.vue');
const ProductClassEdit = () => import('../../views/product/ProductClassEdit.vue');
const ProductByClassList = () => import('../../views/product/ProductByClassList.vue');
const RecommendClassList = () => import('../../views/product/RecommendClassList.vue');
const RecommendClassEdit = () => import('../../views/product/RecommendClassEdit.vue');
const RecommendProductList = () => import('../../views/product/RecommendProductList.vue');
const BeianList = () => import('../../views/product/BeianList.vue');
const CompanyList = () => import('../../views/insuranceCompany/CompanyList.vue');
const CompanyEdit = () => import('../../views/insuranceCompany/CompanyEdit.vue');

const Container = {
  template: `
    <div class="Container">
      <router-view></router-view>
    </div>
  `,
};

const router = {
  path: '/product/productList',
  name: 'ProductContainer',
  component: Container,
  meta: {
    title: '产品管理',
    icon: 'goods',
  },
  children: [
    {
      path: '/product/productList',
      name: 'ProductListContainer',
      component: Container,
      meta: {
        title: '保险产品',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'ProductList',
          component: ProductList,
          meta: {
            title: '保险产品列表',
          },
        },
        {
          path: '/product/productAdd',
          name: 'ProductAdd',
          component: ProductEdit,
          meta: {
            title: '保险产品新增',
            light: '/product/productList',
          },
        },
        {
          path: '/product/productEdit/:productId',
          name: 'ProductEdit',
          component: ProductEdit,
          meta: {
            title: '保险产品编辑',
            light: '/product/productList',
          },
        },
      ],
    },
    {
      path: '/beian/beianList',
      name: 'BeianListContainer',
      component: Container,
      meta: {
        title: '备案信息管理',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'BeianList',
          component: BeianList,
          meta: {
            title: '备案产品列表',
          },
        },
      ],
    },
    {
      path: '/product/recommendClassList',
      name: 'RecommendClassListContainer',
      component: Container,
      meta: {
        title: '首页推荐险种',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'RecommendClassList',
          component: RecommendClassList,
          meta: {
            title: '首页推荐险种列表',
          },
        },
        {
          path: '/product/recommendClassAdd',
          name: 'RecommendClassAdd',
          component: RecommendClassEdit,
          meta: {
            title: '首页推荐险种新增',
            light: '/product/recommendClassList',
          },
        },
        {
          path: '/product/recommendClassEdit/:classId',
          name: 'RecommendClassEdit',
          component: RecommendClassEdit,
          meta: {
            title: '首页推荐险种编辑',
            light: '/product/recommendClassList',
          },
        },
      ],
    },
    {
      path: '/product/recommendProductList',
      name: 'RecommendProductContainer',
      component: Container,
      meta: {
        title: '首页推荐产品',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'RecommendProductList',
          component: RecommendProductList,
          meta: {
            title: '首页推荐产品列表',
            light: '/product/recommendProductList',
          },
        },
      ],
    },
    {
      path: '/product/productClassList',
      name: 'ProductClassListContainer',
      component: Container,
      meta: {
        title: '查看更多险种',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'ProductClassList',
          component: ProductClassList,
          meta: {
            title: '查看更多险种列表',
          },
        },
        {
          path: '/product/productClassAdd',
          name: 'ProductClassAdd',
          component: ProductClassEdit,
          meta: {
            title: '查看更多险种新增',
            light: '/product/productClassList',
          },
        },
        {
          path: '/product/productClassEdit/:classId',
          name: 'ProductClassEdit',
          component: ProductClassEdit,
          meta: {
            title: '查看更多险种编辑',
            light: '/product/productClassList',
          },
        },
      ],
    },
    {
      path: '/product/productByClassList',
      name: 'ProductByClassListContainer',
      component: Container,
      meta: {
        title: '查看更多产品',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'ProductByClassList',
          component: ProductByClassList,
          meta: {
            title: '查看更多产品列表',
            light: '/product/productByClassList',
          },
        },
      ],
    },
    {
      path: '/product/protectionList',
      name: 'ProtectionListContainer',
      component: Container,
      meta: {
        title: '保障方案',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'ProtectionList',
          component: ProtectionList,
          meta: {
            title: '保障方案列表',
          },
        },
        {
          path: '/product/protectionAdd',
          name: 'ProtectionAdd',
          component: ProtectionEdit,
          meta: {
            title: '保障方案新增',
            light: '/product/protectionList',
          },
        },
        {
          path: '/product/protectionEdit/:protectionId',
          name: 'ProtectionEdit',
          component: ProtectionEdit,
          meta: {
            title: '保障方案编辑',
            light: '/product/protectionList',
          },
        },
      ],
    },
    {
      path: '/insuranceCompany/companyList',
      name: 'CompanyContainer',
      component: Container,
      meta: {
        title: '保险公司管理',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'CompanyList',
          component: CompanyList,
          meta: {
            title: '保险公司列表',
            hideChildren: true,
          },
        },
        {
          path: '/insuranceCompany/companyAdd',
          name: 'CompanyAdd',
          component: CompanyEdit,
          meta: {
            title: '保险公司新增',
            light: '/insuranceCompany/companyList',
          },
        },
        {
          path: '/insuranceCompany/companyEdit/:companyId',
          name: 'CompanyEdit',
          component: CompanyEdit,
          meta: {
            title: '保险公司编辑',
            light: '/insuranceCompany/companyList',
          },
        },
      ],
    },
  ],
};
export default router;



// WEBPACK FOOTER //
// ./src/router/modules/product.js